<template>
  <div>
    <v-container fluid class="white elevation-3 margen d-flex">
      <div class="d-flex justify-start">
        <v-btn small text class="mt-3 mx-3 grey lighten-2" to="/salidaProcesos">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </div>
      <div class="mx-auto">
        <h1>Crear Resguardo</h1>
      </div>
    </v-container>

    <v-card class="ma-3">
      <v-card-title>Datos:</v-card-title>

      <!-- SECCION ARCHIVOS -->
      <div class="text-h6 mx-3">Archivos

      <v-btn color="blue-grey" class="ma-2 white--text" @click="dialog = true">
        Subir Archivo
        <v-icon right dark> mdi-cloud-upload </v-icon>
      </v-btn>
      </div>
      <!-- dialog-->
      <v-dialog v-model="dialog" width="600">
        <v-card>
          <v-card-title>Archivo</v-card-title>
          <v-divider></v-divider>
          <v-card id="excels">
            <v-file-input
              v-model="file"
              color="light-blue darken-4"
              counter
              label="Selecciona el archivo"
              placeholder="Selecciona el archivo"
              prepend-icon="mdi-paperclip"
              outlined
              :show-size="1000"
              class="mx-3"
              accept=".xls,.xlsx"
              :rules="reglasExcel"
              id="excel"
            >
              <template v-slot:selection="{ index, text }">
                <v-chip v-if="index < 2" color="grey darken-1" dark label small>
                  {{ text }}
                </v-chip>

                <span
                  v-else-if="index === 2"
                  class="text-overline grey--text text--darken-3 mx-2"
                >
                  +{{ files.length - 2 }} File(s)
                </span>
                <v-spacer></v-spacer>
              </template>
            </v-file-input>

            <v-card-actions class="d-flex justify-space-around">
              <v-btn color="grey darken-1" dark @click="dialog = false" >
                Cerrar</v-btn
              >
              <v-btn color="green darken-1" dark @click="mostrarExcel">
                Mostrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-card>
      </v-dialog>
      <!--fin dialogo-->
      <v-card-text>
        <v-row>

          <v-col cols="12" sm="12" md="6">
            <v-menu
              v-model="modalFecha"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  filled
                  light
                  v-model="fechaSeleccionada"
                  label="Fecha a entregar"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="fechaSeleccionada"
                @input="modalFecha = false"
                :min="minFecha[0]"
              >
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-autocomplete
              class="mx-2"
              label="Almacen"
              v-model="almacenSeleccionado"
              :items="almacenes"
              item-text="NOMBRE"
              item-value="ALMACEN_ID"
              filled
            />

            <!-- <v-autocomplete
              class="mx-1"
              label="Almacen Entrada (opcional)"
              v-model="almacenEntrada"
              :items="almacenes"
              item-text="NOMBRE"
              item-value="NOMBRE"
              return-object
            /> -->


          </v-col>
        </v-row>

        <v-divider></v-divider>
        <!-- {{piezaSeleccionada}} -->
        <!-- TABLA ARTICULOS -->
        <v-data-table 
        v-if="datosExcel.length > 0"
        class="tamTexto"
        v-model="piezaSeleccionada"
        :items="datosExcel" 
        :headers="columnasArticulo" 
        show-select
        single-select
        item-key="ID"
        :item-class="renglon1"
        @input="log"
        id="tablaHeader"
        >
          <!-- <template v-slot:[`header.data-table-select`] class="primary dark white--text"></template> -->

          <template v-slot:[`item.data-table-select`]="{item}">
            <v-checkbox v-if="item.ID != 1"
            :disabled="item.ID == 1"
            class="pa-0 ma-0"
            :ripple="false"
            v-model="piezaSeleccionada"
            :multiple="true"
            :value="item"
            hide-details
            @click="clear()"></v-checkbox>
          </template>

        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>

      <v-divider></v-divider>

      <!-- BOTONES -->
      <v-card-actions class="d-flex justify-space-around">
        <v-btn class="grey darken-1" dark @click="salir">Cancelar</v-btn>
        <v-btn class="primary" dark @click="crearProceso">Crear proceso</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      //DATOS MANDADOS AL BACKEND
      fechaSeleccionada: '',
      almacenSeleccionado:null,

      //datos para mostrar/modificar
      modalFecha: false,
      minFecha: "",
      piezaSeleccionada:[],
      almacenes:[],

      buscador: "",
      datosExcel: [],
      file: null,

      columnasArticulo: [
        { text: "CLAVE MSP", value: "NOMBRE", class: "primary dark white--text" },
        { text: "CANTIDAD", value: "CANTIDAD", class: "primary dark white--text", },
      ],

      columnas: [
        { text: "DESPIECE", value: "DESPIECE_ID", class: "primary dark white--text",},
        { text: "ARTICULO", value: "ARTICULO_ID", class: "primary dark white--text",},
        { text: "CANTIDAD", value: "CANTIDAD", class: "primary dark white--text",},
        { text: "COSTO", value: "COSTO", class: "primary dark white--text" },
      ],
      //---------------------------------------------------
      reglasExcel:[],
    };
  },

  // -----------------------------------------------------------------------------
  computed: {
    ...mapGetters(["getFechaActual", "getURLAPI", "getUsuario"]),
  },

  // -----------------------------------------------------------------------------
  methods: {

    renglon1( item ){
      return item.ID == 1 ? 'renglon1': '' ;
    },

    // -----------------------------------------------------------------------------
    async getAlmacenes() {
      this.almacenes = (
        await axios.get(`${this.getURLAPI}/Show/allStorage`)
      ).data;
      console.log(this.almacenes);
    },

    // -----------------------------------------------------------------------------
    mostrarExcel() {
      if (this.file == null) {
        this.reglasExcel = [() => "Selecciona un excel"]
        document.getElementById("excel").click()
        return;
        
      } else {
        console.log(this.file);
        let datosForm = new FormData();
        datosForm.append("EXCEL", this.file);

        axios.post(`${this.getURLAPI}/SalidaProcesos/vistaPrevia`, datosForm)
        .then(({ data }) => {
          this.datosExcel = data;
          console.log(data);
          this.dialog = false;
        });
      }
    },

    // -----------------------------------------------------------------------------
    salir() {
      let close = confirm("¿Seguro que quieres salir de la pagina?");
      if (close) {
        this.$router.push("/despiece");
      }
    },

    // -----------------------------------------------------------------------------
    crearProceso() {
      if (this.fechaSeleccionada != "" && this.file != null && this.almacenSeleccionado != null) {
        if (this.piezaSeleccionada) {
          
          let datosForm = new FormData();
          datosForm.append("FECHA", this.fechaSeleccionada);
          datosForm.append("USUARIO_CREADOR", this.getUsuario);
          datosForm.append("EXCEL", this.file);
          datosForm.append("PIEZA", JSON.stringify(this.piezaSeleccionada));
          datosForm.append("ALMACEN_ID", this.almacenSeleccionado);
          // datosForm.append("CLAVE_PRODUCTO", this.datosExcel[0].NOMBRE);
          // datosForm.append("CANTIDAD_PRODUCTO", this.datosExcel[0].CANTIDAD);
          // console.log(this.piezaSeleccionada);

          // SE MANDAN LOS DATOS A LA LIGA PARA CREAR EL DESPIECE
          axios.post(`${this.getURLAPI}/SalidaProcesos/insertarProceso`, datosForm,)
          .then( ({data}) => {
            console.log(data);
            const STATUS = data.STATUS;
            this.$root.vtoast.show({
              message: data.MSG,
              color: STATUS =='OK' ? "success darken-1" : "red darken-1",
              timer: 5000,
              icon: STATUS =='OK' ? 'mdi-check':'mdi-alert-circle-outline',
            });
            if (STATUS == 'OK') {
              this.$router.push('/salidaProcesos')
            }
          });
        
        }
        else{
          this.$root.vtoast.show({
            message: "Selecciona un articulo.",
            color: "black",
            timer: 5000,
            icon: "mdi-alert-circle-outline",
          });
        }
      }
      else{
        this.$root.vtoast.show({
          message: "Verifica que se ingrese Excel, Fecha y Almacen.",
          color: "black",
          timer: 5000,
          icon: "mdi-alert-circle-outline",
        });
      }
    },

    log(){
      console.log(this.piezaSeleccionada);
    },

    clear(){
      console.clear();
    }
  },
  // ---------------------------------------------------------------------------

  // -----------------------------------------------------------------------------
  created() {
    document.title = "Crear Salida Proceso | Bombas y Suministros del Norte";
    this.minFecha = this.getFechaActual.split(" ");
    console.log(this.minFecha);
    this.getAlmacenes();
  },

  //-----------------------------------------------------------------------------------
};
</script>

<style>
.allB {
  border-style: solid;
  border-color: rgba(128, 128, 128, 0.349);
  border-width: 1px 1px 1px 1px;
}
.fade-enter-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.borde {
  border-style: solid;
  border-color: rgba(128, 128, 128, 0.349);
  border-width: 0px 0px 1px 0px;
}
.allBorde {
  border-style: solid;
  border-color: rgba(128, 128, 128, 0.349);
  border-width: 1px 1px 1px 1px;
}

.v-expansion-panel-content__wrap {
  padding: 5px 17px 10px !important;
}

.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

span > a {
  color: white !important;
  text-decoration: none;
}
span > a:hover {
  color: rgb(0, 112, 177) !important;
  text-decoration: underline;
}

.container1 {
  display: grid;
}

.content,
.overlay {
  grid-area: 1 / 1;
}

.renglon1{
  background-color: rgb(214, 211, 21) !important;
}
.renglon1:hover{
  background-color: rgb(201, 198, 21) !important;
}

#tablaHeader thead > tr > th.text-start:first-child{
    background-color: #1976d2 !important;
    border-color: #1976d2 !important;
}
</style>